import { Transition } from '@headlessui/react';

interface TransitionWrapperProps {
    show: boolean;
    children: React.ReactNode;
}

const TransitionWrapper: React.FC<TransitionWrapperProps> = ({ show, children }) => (
    <Transition
        as={'div'}
        show={show}
        enter='transition-opacity duration-300'
        enterFrom='opacity-0'
        enterTo='opacity-100'
        leave='transition-opacity duration-300'
        leaveFrom='opacity-100'
        leaveTo='opacity-0'
        className={show ? 'relative w-full flex flex-col items-center' : 'hidden'}
    >
        {children}
    </Transition>
);

export default TransitionWrapper;
